import React, { useCallback, useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
interface NavbarProps {
  handlePurchase: () => void;
}
export function Navbar({
  handlePurchase
}: NavbarProps) {
  const [isOpen, setIsOpen] = useState(false);
  const toggleMenu = () => setIsOpen(prev => !prev);
  const closeMenu = useCallback(() => setIsOpen(false), []);
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && isOpen) closeMenu();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, closeMenu]);
  // Lock body scroll when mobile menu is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  return <>
      <nav className="sticky top-0 z-[9999] bg-[#0A0A0B]/98 border-b border-gold/15 h-[70px] flex items-center justify-between px-[5%]" role="navigation" aria-label="Navegación principal" data-id="element-112">
        <div className="font-serif italic text-gold text-xl font-bold tracking-[2px]" data-id="element-113">
          EL CÓDIGO 888
        </div>

        {/* Desktop Nav */}
        <div className="hidden lg:flex items-center" data-id="element-114">
          <a href="#la-frecuencia" className="text-white text-[11px] font-bold uppercase tracking-[1.5px] transition-colors hover:text-gold mr-5" data-id="element-115">
            La Frecuencia
          </a>
          <a href="#la-ciencia" className="text-white text-[11px] font-bold uppercase tracking-[1.5px] transition-colors hover:text-gold mr-5" data-id="element-116">
            La Ciencia
          </a>
          <a href="#testimonios" className="text-gold text-[11px] font-extrabold uppercase border-b-2 border-gold pb-[2px] mr-5" data-id="element-117">
            Resultados
          </a>
          <a href="#protocolo" className="text-white text-[11px] font-bold uppercase tracking-[1.5px] transition-colors hover:text-gold mr-5" data-id="element-118">
            Protocolo Completo
          </a>
          <button onClick={handlePurchase} className="bg-gold text-dark text-[11px] font-extrabold px-6 py-2.5 rounded shadow-[0_4px_15px_rgba(212,175,55,0.3)] hover:scale-105 transition-transform uppercase tracking-wide" data-id="element-119">
            ACTIVAR - $6.39
          </button>
        </div>

        {/* Mobile Hamburger */}
        <button className="lg:hidden text-gold p-2" onClick={toggleMenu} aria-label={isOpen ? 'Cerrar menú' : 'Abrir menú'} aria-expanded={isOpen} aria-controls="mobile-menu" data-id="element-120">
          {isOpen ? <X size={28} data-id="element-121" /> : <Menu size={28} data-id="element-122" />}
        </button>
      </nav>

      {/* Mobile Overlay */}
      {isOpen && <>
          {/* Backdrop */}
          <div className="fixed inset-0 bg-black/50 z-[9997] lg:hidden" onClick={closeMenu} aria-hidden="true" data-id="element-123" />
          <div id="mobile-menu" role="dialog" aria-modal="true" aria-label="Menú de navegación" className="fixed top-[70px] left-0 right-0 bottom-0 bg-[#0A0A0B] z-[9998] flex flex-col items-center pt-12 space-y-8 lg:hidden overflow-y-auto" data-id="element-124">
            <a href="#la-frecuencia" onClick={closeMenu} className="text-white text-sm font-bold uppercase tracking-[2px]" data-id="element-125">
              La Frecuencia
            </a>
            <a href="#la-ciencia" onClick={closeMenu} className="text-white text-sm font-bold uppercase tracking-[2px]" data-id="element-126">
              La Ciencia
            </a>
            <a href="#protocolo" onClick={closeMenu} className="text-gold text-sm font-bold uppercase tracking-[2px]" data-id="element-127">
              Protocolo Completo
            </a>
            <button onClick={() => {
          closeMenu();
          handlePurchase();
        }} className="mt-4 bg-gold text-dark text-sm font-extrabold px-8 py-3 rounded shadow-[0_4px_15px_rgba(212,175,55,0.3)] uppercase tracking-wide" data-id="element-128">
              Acceso por $6.39
            </button>
          </div>
        </>}
    </>;
}